class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      const buttonRemoveDrawCart = this.querySelector('button.button--tertiary.cart-remove-button');
      const buttonRemoveMainCart = this.querySelector('.btn-remove-product-mini-cart');
      let installationProductId = null;
      if (buttonRemoveDrawCart) {
        installationProductId = buttonRemoveDrawCart.dataset.installationProductId;
      } else if (buttonRemoveMainCart) {
        installationProductId = buttonRemoveMainCart.dataset.installationProductId;
      }

      cartItems.updateQuantity(this.dataset.index, 0, null, null, installationProductId);

    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      const variantId = event.target.dataset.variant
      const parentProductId = event.target.dataset.installationProductId
      this.onChange(event, variantId, parentProductId);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event, variantId, parentProductId) {
    if ((event.target.dataset.variant === window.themeVariables.productGrillInstalation || event.target.dataset.variant === window.themeVariables.productInstalation) && event.target.checked) {
      this.openServicesModal(event.target, variantId, parentProductId);
    } else if ((event.target.dataset.variant === window.themeVariables.productGrillInstalation || event.target.dataset.variant === window.themeVariables.productInstalation) && event.target.checked === false) {
      this.removeServicesProduct(event.target.dataset.variant, event.target.dataset.installationProductId)
    } else {
      this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'), event.target.dataset.quantityVariantId);
    }
  }

  openServicesModal(input, variantId, parentProductId) {

    const servicesModal = document.querySelector(".services-modal")
    const addButton = servicesModal.querySelector(".modal-button")
    const closeButton = servicesModal.querySelector("span.services-modal__close.desktop");
    const closeButton_mob = servicesModal.querySelector(".services-modal__header.mobile span.services-modal__close");


    servicesModal.classList.add("show")

    addButton.addEventListener("click", () => {
      this.addServicesProduct(variantId, parentProductId);
      servicesModal.classList.remove("show")
    })

    closeButton.addEventListener("click", () => {
      servicesModal.classList.remove("show")
      input.checked = false
    })
    closeButton_mob.addEventListener("click", () => {
      servicesModal.classList.remove("show")
      input.checked = false
    })
  }

  addServicesProduct(variantId, parentProductId) {
    const data = {
      items: [
        {
          id: variantId,
          quantity: 1,
          properties: {
            'parent_product_instalation_id': parentProductId
          }
        }
      ],
      sections: [
        'cart-icon-bubble',
        'cart-drawer',
        'main-cart-footer'
      ],
    };

    fetch(`${routes.cart_add_url}.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
      sections: [
        'cart-icon-bubble',
        'cart-drawer',
        'main-cart-footer'
      ],
    })
      .then((response) => response.json())
      .then((data) => {

        const propertiesData = {
          'id': parentProductId,
          properties: {
            '_instalation': true,
            '_installation_product_id': variantId
          },
          sections: this.getSectionsToRender().map((section) => section.section)
        };

        return fetch(`${routes.cart_change_url}.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(propertiesData)

        })
          .then((response) => response.text())
          .then((state) => { // Aqui se actualiza el carrito
            const parsedState = JSON.parse(state);
            this.getSectionsToRender().forEach((section) => {

              const elementToReplace =
                document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
              elementToReplace.innerHTML = this.getSectionInnerHTML(
                parsedState.sections[section.section],
                section.selector
              );
            });


          })
          .catch((e) => {
            console.error(e);
          });
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        document.querySelector(".services-modal__terms input[type='checkbox']").checked = false;
      });
  }

  removeServicesProduct(variantId, parentProductId) {

    const propertiesData = {
      'id': parentProductId,
      properties: {
        '_instalation': false
      }
    };

    fetch(`${routes.cart_change_url}.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(propertiesData)
    })
      .then((response) => response.json())
      .then((response) => {

        const data = {
          updates: {
            [variantId]: 0,
          },
          sections: this.getSectionsToRender().map((section) => section.section)
        };

        return fetch(`${routes.cart_update_url}.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(data),
        })
          .then((response) => response.json())
          .then((state) => { // se actualiza
            const parsedState = state;
            this.getSectionsToRender().forEach((section) => {

              const elementToReplace =
                document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
              elementToReplace.innerHTML = this.getSectionInnerHTML(
                parsedState.sections[section.section],
                section.selector
              );
            });
          })
          .catch((e) => {
            console.error(e);
          });


      })
      .catch((e) => {
        console.error(e);
      });

  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-icon-bubble-mobile',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId, installationProductId) {

    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');
        const cartEmpty = document.getElementById('cart-empty');
        const itemDelivery = document.getElementsByClassName('cart-items__delivery');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartEmpty) cartEmpty.classList.toggle('is-empty', parsedState.item_count === 0);
        if (itemDelivery && itemDelivery.length) itemDelivery[0].classList.toggle('is-empty', parsedState.item_count === 0);

        if (installationProductId === null || installationProductId === undefined || installationProductId === '') {
          this.getSectionsToRender().forEach((section) => {
            const elementToReplace =
              document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
            elementToReplace.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            );
          });
        }

        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }

        // Remover productos de instalación cuando se remueve el producto padre
        if (installationProductId !== null && installationProductId !== undefined && installationProductId !== '') {
          this.enableLoading(1);
          const bodyInst = ({
            id: installationProductId,
            quantity: 0,
            sections: this.getSectionsToRender().map((section) => section.section),
            sections_url: window.location.pathname,
          });

          fetch(`${routes.cart_change_url}.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(bodyInst)
          })
            .then((response) => {
              return response.text();


            })
            .then((state) => {
              const parsedState = JSON.parse(state);
              this.classList.toggle('is-empty', parsedState.item_count === 0);
              const cartDrawerWrapper = document.querySelector('cart-drawer');
              const cartFooter = document.getElementById('main-cart-footer');
              const cartEmpty = document.getElementById('cart-empty');

              if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
              if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
              if (cartEmpty) cartEmpty.classList.toggle('is-empty', parsedState.item_count === 0);

              this.getSectionsToRender().forEach((section) => {

                const elementToReplace =
                  document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

                elementToReplace.innerHTML = this.getSectionInnerHTML(
                  parsedState.sections[section.section],
                  section.selector
                );


              });

              const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
              let message = '';
              if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
                if (typeof updatedValue === 'undefined') {
                  message = window.cartStrings.error;
                } else {
                  message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
                }
              }


            })
            .catch((e) => {
              console.error(e);
            });
        }
        // End Remover productos de instalación cuando se remueve el producto padre

        // Terminos y condiciones when change quantity in cart
        var termsConditionsCheckbox = document.querySelector('#terms-conditions');
        var checkoutButton = document.querySelector('#checkout');
        if (termsConditionsCheckbox) {
          termsConditionsCheckbox.addEventListener('change', function () {
            if (this.checked) {
              checkoutButton.removeAttribute('disabled');
            } else {
              checkoutButton.setAttribute('disabled', 'disabled');
            }
          });
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }


        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
        // Add data region and comuna to cart form from local storage

        // var form = document.getElementById('cart-form-regioncomuna');

        // var regionValue = localStorage.getItem('region');
        // var comunaValue = localStorage.getItem('comuna');
        // if (window.cartTemplate === 'cart') {
        //   if (regionValue && comunaValue) {
        //     form.action =
        //       '/cart?step=contact_information&checkout[shipping_address][country]=CL&checkout[shipping_address][province]=' +
        //       encodeURIComponent(regionValue) +
        //       '&checkout[shipping_address][city]=' +
        //       encodeURIComponent(comunaValue);
        //   }
        // }

      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'change',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}

